// Turn an axios/FastAPI error into a readable string. FastAPI validation
// errors (422) return `detail` as an array of {msg,...} objects, which is why
// naive `alert(detail)` shows "[object Object]".
export function apiErrorMessage(error: any, fallback = 'Something went wrong. Please try again.'): string {
  const d = error?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) {
    const msgs = d.map((e: any) => (typeof e === 'string' ? e : e?.msg)).filter(Boolean);
    if (msgs.length) return msgs.join('. ');
  }
  if (d && typeof d === 'object' && typeof d.msg === 'string') return d.msg;
  return error?.message || fallback;
}
